import React, { useMemo } from "react";
import { Box, Typography, Tooltip, Grid, useTheme } from "@mui/material";

const CheckinHeatmap = ({ rawData = [] }) => {
  const theme = useTheme();

  const rows = useMemo(() => {
    const result = [];
    const verticals = [...new Set(rawData.map((d) => d.Business_Vertical_Desc))];

    verticals.forEach((bv) => {
      const data = rawData.filter((d) => d.Business_Vertical_Desc === bv);
      const rowIn = { vertical: bv, type: "Check-In", values: Array(24).fill(0) };
      const rowOut = { vertical: bv, type: "Check-Out", values: Array(24).fill(0) };

      data.forEach((d) => {
        const hour = Number(d.HourOfDay);
        const total = Number(d.TotalEmployees || 0);
        if (total > 0) {
          rowIn.values[hour] = Number(((d.CheckIns / total) * 100).toFixed(1));
          rowOut.values[hour] = Number(((d.CheckOuts / total) * 100).toFixed(1));
        }
      });

      result.push(rowIn, rowOut);
    });

    return result;
  }, [rawData]);

  return (
    <Box> 
      <Box display="flex" fontSize={11} pl={19}>
        {[...Array(24).keys()].map((h) => (
          <Box key={h} width={28} textAlign="center">
            {h}
          </Box>
        ))}
      </Box>

      {rows.map((row, idx) => (
        <Grid
          container
          key={idx}
          spacing={1}
          alignItems="center"
          sx={{ mb: 0.0 }}
        >
          <Grid item width={140}>
            <Typography
                    fontSize={12}
                    sx={{
                        color: row.type === "Check-In" ? "#4CAF50" : "#F44336",
                        fontWeight: 500,
                    }}
                    >
                    {row.vertical}
                    </Typography>
          </Grid>

          <Grid item flex={1}>
            <Box display="flex">
              {row.values.map((val, i) => {
                const bgColor =
                  row.type === "Check-In"
                    ? `rgba(76, 175, 80, ${Math.min(val / 100, 1).toFixed(2)})`
                    : `rgba(244, 67, 54, ${Math.min(val / 100, 1).toFixed(2)})`;

                return (
                  <Tooltip
                    key={i}
                    title={`${i}:00 - ${val}%`}
                    placement="top"
                    arrow
                  >
                    <Box
                      sx={{
                        width: 28,
                        height: 22,
                        bgcolor: bgColor,
                        border: "1px solid #ccc",
                        fontSize: 10,
                        textAlign: "center",
                        lineHeight: "22px",
                        color: val > 60 ? "#fff" : "#000",
                      }}
                    >
                      {val > 0 ? `${val.toFixed(0)}%` : ""}
                    </Box>
                  </Tooltip>
                );
              })}
            </Box>
          </Grid>
        </Grid>
      ))}
    </Box>
  );
};

export default CheckinHeatmap;
